import { unwrapResponse, unwrapVoid } from '../http.js';
export function createMediaApi(client, transport) {
    return {
        async upload(file, purpose) {
            const form = new FormData();
            // En React Native el valor no es un `Blob` sino el descriptor
            // `{ uri, name, type }`; su `FormData` lo entiende, pero el tipo de la
            // firma estándar no lo contempla.
            form.append('file', file);
            form.append('purpose', purpose);
            return unwrapResponse(await transport.postMultipart('/v1/media', form));
        },
        async remove(id) {
            unwrapVoid(await client.DELETE('/v1/media/{id}', { params: { path: { id } } }));
        },
    };
}
//# sourceMappingURL=media.js.map